import { useCallback, useEffect } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// local imports
import { DashboardService } from 'app/services';
import useDataApi from '../../use-data-api';
import { TableUtils } from 'app/utils';

const useGetDashboardDetailService = queries => {
  const [service, setService] = useDataApi();

  const isTurpPharmacy = condition => (
    <>
      {!condition ? (
        <CancelIcon fontSize="large" color="error" />
      ) : (
        <CheckCircleIcon fontSize="large" color="action" className="text-green-600" />
      )}
    </>
  );

  const fetchData = useCallback(async () => {
    // ticket topics
    const dashboardDetail = await DashboardService.getDashboardDetail(queries);
    const dashboardDetailData = dashboardDetail?.data?.data;

    const { pharmacy, ...rest } = dashboardDetailData;

    const out = pharmacy.map(item => {
      const { id, created_at, status, city, district, region, is_turp_pharmacy, ...rest } = item;

      return {
        ...rest,
        city: city.name,
        district: district.name,
        region: region.name,
        is_turp_pharmacy: isTurpPharmacy(is_turp_pharmacy)
      };
    });

    return {
      ...rest,
      table: {
        columns: TableUtils.dashboardPharmacyList,
        rows: out
      }
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useGetDashboardDetailService;
